<template>
  <div class="w-full flex flex-col items-center min-h-[89vh]">
    <div class="header w-full">
      <div class="flex justify-between items-center w-full mb-4">
        <h1 class="title-main-account">{{ $t('team.title') }}</h1>
      </div>
      <div class="mt-4 mb-6 border-t border-blue-200"></div>
    </div>

    <div class="w-full flex flex-col items-center" v-if="!showInscription">
      <div class="multi-user-section mt-8 flex flex-col gap-6 p-6 bg-white rounded-lg shadow-lg w-full max-w-4xl">
        <h2 class="title-settings mb-4">{{ $t('member.title') }}</h2>
        <div v-if="multiUsers.length === 0">
          <p class="text-settings">{{ $t('member.noneFound') }}</p>
        </div>
        <div v-else>

          <div
            class="flex items-center justify-between p-4 transition-colors -mx-6 w-[calc(100%+3rem)] cursor-default bg-white hover:bg-blue-100"
          >
            <div class="flex items-center space-x-4 flex-grow">
              <div class="flex items-center gap-2">
                <span class="font-semibold text-settings">
                  {{ nom_owner }} {{ prenom_owner }}
                </span>
                <span title="Owner Premium" class="ml-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <path d="M23.0173 6.18328L20.4485 16.072C20.3738 16.3584 20.2063 16.612 19.9722 16.7931C19.7382 16.9742 19.4507 17.0728 19.1548 17.0733H4.84475C4.54879 17.0728 4.26133 16.9742 4.02728 16.7931C3.79322 16.612 3.62574 16.3584 3.551 16.072L0.98225 6.18328C0.919786 5.94526 0.92425 5.69461 0.99515 5.45896C1.06605 5.22331 1.20063 5.01181 1.38407 4.84777C1.5675 4.68372 1.79266 4.57351 2.03474 4.52927C2.27681 4.48503 2.5264 4.50848 2.756 4.59704L7.01225 6.23578C7.05529 6.25252 7.10257 6.255 7.14713 6.24285C7.19169 6.23069 7.23116 6.20456 7.25975 6.16829L10.946 1.44329C11.0704 1.28224 11.2301 1.15185 11.4128 1.06214C11.5954 0.972428 11.7962 0.925781 11.9998 0.925781C12.2033 0.925781 12.4041 0.972428 12.5867 1.06214C12.7694 1.15185 12.9291 1.28224 13.0535 1.44329L16.7397 6.16829C16.7683 6.20456 16.8078 6.23069 16.8524 6.24285C16.8969 6.255 16.9442 6.25252 16.9872 6.23578L21.2435 4.59704C21.473 4.51237 21.7212 4.4918 21.9615 4.53754C22.2018 4.58328 22.4251 4.69361 22.6075 4.85667C22.7898 5.01974 22.9243 5.22938 22.9965 5.4631C23.0687 5.69682 23.0759 5.94579 23.0173 6.18328Z" fill="url(#paint0_linear_1291_79)"/>
                    <defs>
                      <linearGradient id="paint0_linear_1291_79" x1="0.938" y1="8.99953" x2="23.0686" y2="8.99953" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FFDE00"/>
                        <stop offset="1" stop-color="#FD5900"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
              </div>
            </div>

            <div class="flex items-center gap-9">
              <div class="flex items-center gap-1 border px-5 py-2 rounded bg-white">
                <i class="fas fa-user"></i>
                <span>{{ totalAccounts }}</span>
              </div>

              <button disabled class="opacity-0 cursor-default">
                <i class="fas fa-edit"></i>
              </button>

              <!-- <button disabled class="opacity-0 cursor-default">
                <i class="fas fa-trash-alt"></i>
              </button> -->
            </div>
          </div>
          <div
            v-for="(user, index) in multiUsers"
            :key="user.Id"
            class="flex items-center justify-between p-4 transition-colors -mx-6 w-[calc(100%+3rem)] cursor-pointer"
            :class="{
              'bg-blue-100': activeUser === user.Email_Gologin,
              'bg-white': index % 2 !== 0 && activeUser !== user.Email_Gologin,
              'bg-gray-100': index % 2 === 0 && activeUser !== user.Email_Gologin,
              'hover:bg-blue-100': true,
              'opacity-50': user.isPreparing,
            }"
            @click.stop="openEditModal(user)" 
          >
          <div class="flex items-center space-x-4 flex-grow">
            <img
                  v-if="user.not_accepted"
                  src="@/assets/sendit.png"
                  alt="En attente"
                  class="w-[3rem] h-[3rem]"
                />
            <div class="flex flex-col">
              <span
                class="font-semibold text-settings flex items-center gap-2"
                :class="{ 'text-gray-400': user.not_accepted }"
              >
                {{ user.Nom }} {{ user.Pr_nom }}
              </span>
              <span
                class="text-sm"
                :class="user.not_accepted ? 'text-gray-400' : 'text-gray-500'"
              >
                {{ user.Email_Gologin }}
              </span>
            </div>
          </div>

          <div class="flex items-center gap-9">
            <div class="flex items-center gap-1 border px-5 py-2 rounded bg-white">
              <i class="fas fa-user"></i>
              <span>
                {{ user.Comptes ? user.Comptes.split(',').filter(c => c.trim() !== '').length : 0 }}
              </span>
            </div>

            <button @click.stop="openEditModal(user)" class="text-blue-500 hover:text-blue-700">
              <i class="fas fa-edit"></i>
            </button>
<!-- 
            <button @click.stop="confirmDelete(user)" class="text-red-500 hover:text-red-700">
              <i class="fas fa-trash-alt"></i>
            </button> -->
          </div>
        </div>

        </div>
        <div class="w-full h-px bg-[#C9C9C9] mt-6"></div>
        <div class="w-full flex justify-center mt-6">
          <form @submit.prevent="inviteUser" class="flex items-end gap-4 w-full">
            <div class="flex flex-col w-1/4">
              <label class="text-settings mb-1">{{ $t('member.firstName') }}</label>
              <input
                type="text"
                placeholder="First Name"
                class="form-input px-4 py-2 border border-gray-300 rounded-md"
                v-model="firstName"
                required
              />
            </div>
            <div class="flex flex-col w-1/4">
              <label class="text-settings mb-1">{{ $t('member.lastName') }}</label>
              <input
                type="text"
                placeholder="Last Name"
                class="form-input px-4 py-2 border border-gray-300 rounded-md"
                v-model="lastName"
                required
              />
            </div>
            <div class="flex flex-col w-1/3">
              <label class="text-settings mb-1">{{ $t('member.email') }}</label>
              <input
                type="email"
                placeholder="Email"
                class="form-input px-4 py-2 border border-gray-300 rounded-md"
                v-model="email"
                required
              />
            </div>
            <button
              type="submit"
              class=" button-continu text-[20px] text-white px-8 py-4 rounded-full font-semibold inline-flex items-center justify-center mt-5"
              >
              {{ $t('member.invite') }}
            </button>
          </form>
        </div>
      </div>
    </div>

    <div v-if="showInscription" class="w-full flex flex-col items-center">
      <div class="multi-user-section mt-8 p-6 bg-white rounded-lg shadow-lg w-full max-w-4xl flex flex-col gap-6">
        <h2 class="title-settings text-left"> {{ $t('member.title') }}</h2>
        <div class="mx-auto w-24 h-24 flex items-center justify-center mt-5">
          <img 
            src="@/assets/fi_9178659.png" 
            alt="icon" 
            class="w-full h-full object-contain" 
          />
        </div>
        

        <form @submit.prevent="inviteUser" class="w-full max-w-md mx-auto flex flex-col items-center gap-4 mt-5">
          <p class="text-center mb-5">
            {{ $t('member.noInvites') }}
          </p>
          <div class="flex gap-2 w-full">
            <div class="flex-1">
              <label for="firstName" class="block label-settings mb-1">{{ $t('member.firstName') }}</label>
              <input
                id="firstName"
                type="text"
                placeholder="First Name"
                class="form-input w-full px-4 py-2 border border-gray-300 rounded-md"
                v-model="firstName"
                required
              />
            </div>
            <div class="flex-1">
              <label for="lastName" class="block label-settings mb-1">{{ $t('member.lastName') }}</label>
              <input
                id="lastName"
                type="text"
                placeholder="Last Name"
                class="form-input w-full px-4 py-2 border border-gray-300 rounded-md"
                v-model="lastName"
                required
              />
            </div>
          </div>

          <div class="w-full mt-4">
            <label for="email" class="block label-settings mb-1">{{ $t('member.email') }}</label>
            <input
              id="email"
              type="email"
              placeholder="Email"
              class="form-input w-full px-4 py-2 border border-gray-300 rounded-md"
              v-model="email"
              required
            />
          </div>

          <button
            type="submit"
            class="w-full button-continu text-[20px] text-white px-8 py-4 rounded-full font-semibold inline-flex items-center justify-center mt-5"
            >
            {{ $t('member.invite') }}
          </button>
        </form>
      </div>
    </div>

    <div 
      v-if="showDeleteModal" 
      class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="bg-white p-[2rem] rounded-lg shadow-md w-full max-w-[50%]">
        <h2 class="modal-title mb-4 items-center">
          {{ $t('member.confirmDeleteTitle') }}
        </h2>
        
        <p class="modal-text mb-4 items-center">
          {{ $t('member.confirmDeleteText') }}
          <strong>{{ userToDelete.Email_Gologin }}</strong> ?
        </p>

        <div class="mt-8 space-y-4 text-settings">
          <div><strong>{{ $t('member.lastName') }}</strong> {{ userToDelete.Nom }}</div>
          <div><strong>{{ $t('member.firstName') }}</strong> {{ userToDelete.Pr_nom }}</div>
          <div><strong>{{ $t('member.email') }}</strong> {{ userToDelete.Email_Gologin }}</div>
          <div><strong>{{ $t('member.language') }}</strong> {{ userToDelete.Langue }}</div>
          <div>
            <h3 class="text-md font-semibold ">{{ $t('member.linkedAccountsTitle') }}</h3>

            <div v-if="userToDeleteAccounts.length > 0" class="space-y-4">
              <div
                v-for="acc in userToDeleteAccounts"
                :key="acc.email"
                class="flex items-center justify-between py-4 border-b"
              >
                <div class="flex items-center">
                  <img 
                    :src="acc.photo && JSON.parse(acc.photo).length 
                          ? JSON.parse(acc.photo)[0].url 
                          : require('../assets/profil.png')"  
                    alt="Avatar" 
                    class="w-[65px] h-[65px] rounded-full object-cover"
                  />
                  <span class="ml-4 title-avatar">{{ acc.compte }}</span>
                </div>
              </div>
            </div>

            <p v-else class="text-sm text-gray-500 italic"> {{ $t('member.noLinkedAccounts') }}</p>
          </div>
        </div>

        <div class="flex justify-end mt-4 gap-3">
          <button 
            @click="closeDeleteModal" 
            class="flex-1 border back-button px-4 py-2 rounded-full text-sm font-semibold"
          >
          {{ $t('member.back') }}
          </button>
          <button 
            @click="deleteMultiUser" 
            class="flex-1 h-[42px] bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold rounded-full"
          >
          {{ $t('member.delete') }}
          </button>
        </div>
      </div>
    </div>


    <div 
      v-if="showAccountModal"
      class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="bg-white p-[2rem] rounded-lg shadow-md w-full max-w-[50%]">
        <div>
        <h2 class="modal-title mb-4 items-center">
          {{ $t('member.accessTitle', { name: userFullName }) }}
        </h2>
        <p class="modal-text mb-4 items-center">
          {{ $t('member.accessDescription') }}
        </p>

        <div class="flex items-center gap-3 mb-4 mt-[2rem]">
          <div class="relative flex-1">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" stroke-width="2"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1011 18.5a7.5 7.5 0 005.65-2.85z" />
              </svg>
            </span>
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Search..."
              class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div class="relative">
            <select
              id="sortSelect"
              v-model="sortOption"
              class="appearance-none border border-blue-500 text-gray-600 py-2 pl-10 pr-6 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">{{ $t('member.sortBy') }}</option>
              <option value="asc">A → Z</option>
              <option value="desc">Z → A</option>
            </select>

            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7 7l3-3 3 3H7zm0 6h6l-3 3-3-3z" />
              </svg>
            </div>
          </div>
        </div>


        <div class="flex items-center mt-4 gap-3">
          <span class="selectall-avatar">{{ $t('member.selectAll') }}</span>
          <input 
            type="checkbox" 
            @change="toggleAllAccounts" 
            class="w-5 h-5 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
          />
        </div>
        <div class="overflow-y-auto max-h-[50vh] pr-2">
          <div 
            v-for="acc in filteredAndSortedAccounts" 
            :key="acc.id" 
            class="flex items-center justify-between py-4 border-b"
          >
            <div class="flex items-center">
              <img 
                :src="acc.photo && JSON.parse(acc.photo).length 
                      ? JSON.parse(acc.photo)[0].url 
                      : require('../assets/profil.png')"  
                alt="Avatar" 
                class="w-[65px] h-[65px] rounded-full object-cover"
              />
              <span class="ml-4 title-avatar">{{ acc.compte }}</span>
            </div>

            <input 
              type="checkbox" 
              v-model="acc.selected"
              class="w-5 h-5 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
            />
          </div>
        </div>
      </div>
        <div class="flex justify-between mt-4 gap-3">
          <button 
            @click="cancelAccountSelection" 
            class="flex-1 border back-button px-4 py-2 rounded-full text-sm font-semibold"
          >
          {{ $t('member.back') }}
          </button>

          <button 
            @click="submitAccounts" 
            class="flex-1 h-[42px] bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold rounded-full"
          >
          {{ $t('member.add') }}
          </button>
        </div>
      </div>
    </div>


    <div 
      v-if="showEditModal"
      class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="relative bg-white p-[2rem] rounded-lg shadow-md w-full max-w-[50%]">
        <button 
          @click="closeEditModal"
          class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-[2rem] font-bold focus:outline-none"
          aria-label="Fermer la fenêtre"
        >
          &times;
        </button>
        <div>

          <h2 class="modal-title mb-4 items-center">
            {{ $t('member.editTitle') }}
            <span class="font-normal">
              {{ userToEdit ? userToEdit.Email_Gologin : '' }}
            </span>
          </h2>

          <p class="modal-text mb-4 items-center mt-[2rem]">
            {{ $t('member.editDescription') }}
          </p>

          <div class="mb-4">
            <label class="text-settings mb-1" for="editFirstName">{{ $t('member.firstName') }}</label>
            <input
              id="editFirstName"
              v-model="firstName_modif"
              type="text"
              class="w-full px-4 py-2 border border-gray-300 rounded-md 
                    focus:outline-none focus:ring-blue-500 
                    focus:border-blue-500"
            />
          </div>

          <div class="mb-4">
            <label class="text-settings mb-1" for="editLastName">{{ $t('member.lastName') }}</label>
            <input
              id="editLastName"
              v-model="lastName_modif"
              type="text"
              class="w-full px-4 py-2 border border-gray-300 rounded-md 
                    focus:outline-none focus:ring-blue-500 
                    focus:border-blue-500"
            />
          </div>

          <div class="flex items-center gap-3 mb-4 mt-[2rem]">
            <div class="relative flex-1">
              <span class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" stroke-width="2"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1011 18.5a7.5 7.5 0 005.65-2.85z" />
                </svg>
              </span>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md
                      focus:outline-none focus:ring-blue-500 
                      focus:border-blue-500"
              />
            </div>

            <div class="relative">
              <select
                id="sortSelect2"
                v-model="sortOption"
                class="appearance-none border border-blue-500 text-gray-600 
                      py-2 pl-10 pr-6 rounded-md focus:outline-none 
                      focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">{{ $t('member.sortBy') }}</option>
                <option value="asc">A → Z</option>
                <option value="desc">Z → A</option>
              </select>

              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M7 7l3-3 3 3H7zm0 6h6l-3 3-3-3z" />
                </svg>
              </div>

         
            </div>
          </div>

          <div class="flex items-center mt-4 gap-3">
            <span class="selectall-avatar">{{ $t('member.selectAll') }}</span>
            <input 
              type="checkbox" 
              @change="toggleAllAccounts" 
              class="w-5 h-5 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
            />
          </div>
          <div class="overflow-y-auto max-h-[50vh] pr-2">
            <div
              v-for="acc in filteredAndSortedAccounts" 
              :key="acc.id" 
              class="flex items-center justify-between py-4 border-b"
            >
              <div class="flex items-center">
                <img 
                  :src="acc.photo && JSON.parse(acc.photo).length 
                        ? JSON.parse(acc.photo)[0].url 
                        : require('../assets/profil.png')"  
                  alt="Avatar" 
                  class="w-[65px] h-[65px] rounded-full object-cover"
                />
                <span class="ml-4 title-avatar">{{ acc.compte }}</span>
              </div>
              <input 
                type="checkbox" 
                v-model="acc.selected"
                class="w-5 h-5 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
          <div class="flex justify-between mt-4 gap-3">
            <button 
              @click="confirmDelete(userToEdit)" 
              class="flex-1 h-[42px] bg-gradient-to-r from-red-500 to-red-600
                    hover:from-red-600 hover:to-red-700 text-white font-bold
                    rounded-full"
            >
            {{ $t('member.delete') }}
            </button>

            <button 
              @click="updateMultiUser" 
              class="flex-1 h-[42px] bg-gradient-to-r from-blue-500 to-blue-600 
                    hover:from-blue-600 hover:to-blue-700 text-white font-bold 
                    rounded-full"
            >
            {{ $t('member.modify') }}
            </button>
          </div>

       
      </div>
    </div>



    <div 
      v-if="showToast" 
      :class="[
        'fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 text-white font-semibold rounded-lg shadow-lg transition-opacity duration-300',
        toastType === 'success' ? 'bg-green-500' : 'bg-red-500'
      ]"
      style="z-index: 9999;"
    >
      <i 
        :class="toastType === 'success' ? 'fas fa-check-circle mr-2' : 'fas fa-exclamation-circle mr-2'"
      ></i>
      {{ toastMessage }}
    </div>
  </div>
</template>

<script>
import api from '../plugins/axios';

export default {
  name: 'MultiUserManagement',
  data() {
    return {
      multiUsers: [],
      showDeleteModal: false,
      userToDelete: null,
      userToDeleteAccounts: [],

      showInscription: false,
      firstName: '',
      lastName: '',
      email: '',

      firstName_modif: '',
      lastName_modif: '',
      email_modif: '',
      
      subscriptions: JSON.parse(localStorage.getItem('subscriptions')) || [],

      showAccountModal: false,
      accounts: [], 

      showEditModal: false,
      userToEdit: null,

      searchQuery: '',
      sortOption: '',

      toastMessage: '',
      showToast: false,
      toastType: 'success',

      nom_owner: localStorage.getItem('nom') || '',
      prenom_owner: localStorage.getItem('prenom') || '',
    };
  },
  computed: {
    totalAccounts() {
      return this.subscriptions.reduce((sum, sub) => sum + sub.quantity, 0);
    },
    userFullName() {
      return `${this.firstName} ${this.lastName}`.trim();
    },
    filteredAndSortedAccounts() {
      let results = [...this.accounts];

      if (this.searchQuery.trim()) {
        const lowerSearch = this.searchQuery.toLowerCase();
        results = results.filter(acc => {
          return acc.compte.toLowerCase().includes(lowerSearch);
        });
      }

      if (this.sortOption === 'asc') {
        results.sort((a, b) => a.compte.localeCompare(b.compte));
      } else if (this.sortOption === 'desc') {
        results.sort((a, b) => b.compte.localeCompare(a.compte));
      }

      return results;
    },
  },
  methods: {
    openEditModal(user) {
      this.userToEdit = { ...user }; 
 
      this.firstName_modif = user.Pr_nom || '';
      this.lastName_modif  = user.Nom || '';
      this.email_modif     = user.Email_Gologin || '';

      this.fetchAccountsForEdit();
      
      this.showEditModal = true;
    },

    async fetchAccountsForEdit() {
      try {
        const response = await api.get('/api/comptes');
        
        const userAccountsArray = (this.userToEdit.Comptes || '')
          .split(',')
          .map(c => c.trim())
          .filter(c => c !== '');
        
        this.accounts = response.data.map(acc => {
          const isSelected = userAccountsArray.includes(acc.email); 
          return {
            ...acc,
            selected: isSelected
          };
        });
      } catch (error) {
        console.error('Erreur lors de la récupération des comptes:', error);
        this.showToastMessage('Impossible de récupérer la liste des comptes.', 'error');
      }
    },


    async updateMultiUser() {
      try {
        const selectedIds = this.accounts
          .filter(acc => acc.selected)
          .map(acc => acc.email);

        const payload = {
          email: this.userToEdit.Email_Gologin,              
          comptesEmails: selectedIds,      
          firstName: this.firstName_modif,
          lastName: this.lastName_modif,
        };

        await api.post('/api/multi-user/comptes', payload);

        this.showToastMessage('Utilisateur mis à jour avec succès.', 'success');
        this.showEditModal = false;
        this.fetchMultiUsers();

      } catch (error) {
        console.error('Erreur lors de la modification du multi user:', error);
        this.showToastMessage('Erreur lors de la modification du multi user.', 'error');
      }
    },

    closeEditModal() {
      this.showEditModal = false;
      this.userToEdit = null;
    },


    async fetchMultiUsers() {
      try {
        const response = await api.get('/api/multi-user');
        if(response.data && response.data.length > 0) {
          this.multiUsers = response.data;
          this.showInscription = false;
        } else {
          this.multiUsers = [];
          this.showInscription = true;
        }
      } catch(error) {
        console.error('Erreur lors de la récupération des multi users:', error);
        this.showToastMessage('Erreur lors de la récupération des multi users.', 'error');
      }
    },

    async inviteUser() {
      try {
        const response = await api.get('/api/comptes');
        this.accounts = response.data.map(acc => ({
          ...acc,
          selected: false
        }));

        this.showAccountModal = true;

      } catch (error) {
        console.error('Erreur lors de la récupération des comptes:', error);
        this.showToastMessage('Impossible de récupérer la liste des comptes.', 'error');
      }
    },

    cancelAccountSelection() {
      this.showAccountModal = false;
    },

    toggleAllAccounts(event) {
      const checked = event.target.checked;
      this.filteredAndSortedAccounts.forEach(acc => {
        acc.selected = checked;
      });
    },

    async submitAccounts() {
      try {
        const selectedIds = this.accounts
          .filter(acc => acc.selected)
          .map(acc => acc.email);

        const payload = {
          email: this.email,
          comptesEmails: selectedIds,
          firstName: this.firstName,
          lastName: this.lastName,
        };

        await api.post('/api/multi-user/comptes', payload);

        this.showToastMessage('Utilisateur invité avec succès.', 'success');
        this.showAccountModal = false;

        this.email = '';
        this.firstName = '';
        this.lastName = '';
        this.accounts.forEach(acc => acc.selected = false);
        this.searchQuery = '';
        this.sortOption = '';

        this.fetchMultiUsers();
      } catch (error) {
        console.error('Erreur lors de la création du multi user:', error);
        this.showToastMessage('Erreur lors de la création du multi user.', 'error');
      }
    },

    async confirmDelete(user) {
      try {
        this.showEditModal = false;
        this.userToDelete = { ...user };

        const response = await api.get('/api/comptes'); 

        const userAccountsArray = (user.Comptes || '')
          .split(',')
          .map(c => c.trim())
          .filter(c => c !== '');

        this.userToDeleteAccounts = response.data
          .filter(acc => userAccountsArray.includes(acc.email))
          .map(acc => ({
            ...acc
          }));

        this.showDeleteModal = true;
      } catch (error) {
        console.error('Erreur lors de la récupération des comptes du user à supprimer', error);
        this.userToDeleteAccounts = [];
        this.showToastMessage('Impossible de récupérer les comptes associés.', 'error');
      }
    },
    closeDeleteModal() {
      this.userToDelete = null;
      this.showDeleteModal = false;
    },
    async deleteMultiUser() {
      try {
        await api.delete('/api/multi-user', { data: { email: this.userToDelete.Email_Gologin } });
        this.showToastMessage('Multi user supprimé avec succès.', 'success');
        this.closeDeleteModal();
        await this.fetchMultiUsers();
      } catch (error) {
        console.error('Erreur lors de la suppression du multi user:', error);
        this.showToastMessage('Erreur lors de la suppression du multi user.', 'error');
      }
    },

    showToastMessage(message, type = 'success') {
      this.toastMessage = message;
      this.toastType = type;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
        this.toastMessage = '';
      }, 3000);
    }
  },
  mounted() {
    this.fetchMultiUsers();
  }
};
</script>

<style scoped>


.multi-user-section {
    max-width: 80%;
    padding: 2rem;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 0px 10px 40px 0px rgba(30, 147, 253, 0.20);
  }


.title-main-account {
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 700;
  color: #2C2C2C;
}

.title-settings {
  color: #000;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; 
}

.text-settings {
  font-family: Montserrat;
  font-size: 14px;
  color: #000;
}

.comptes-text {
  white-space: pre-wrap;
  font-family: Montserrat;
  font-size: 14px;
  color: #000;
}

.text-center{
  align-self: stretch;
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; 
}

.label-settings{
  color: #000;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}


.button-continu {
  background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
  box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
  transition: background 1s ease, box-shadow 1s ease; 
  color: #FFF;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.button-continu:hover {
  background: linear-gradient(90deg, #3154C8 0%, #3154C8 100%);
  box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
}

.modal-title{
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
}

.modal-text{
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; 
}

.title-avatar{
  color: #0A66C2;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; 
}

.selectall-avatar{
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.back-button{
  margin-right: 10px;
  border: 1px solid #5d5052;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  text-transform: uppercase; 
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  color: gray;

}


.back-button:hover {
  background: var(--gradient, linear-gradient(90deg, #5d5052 0%, gray 100%));
  color: #ffffff; 
}

.back-button:hover span {
  color: #ffffff !important; 
  -webkit-text-fill-color: #ffffff !important;
}

.back-button:hover i {
  color: #ffffff; 
  -webkit-text-fill-color: #ffffff;
}

.back-button i, .back-button span {
  background: var(--gradient, linear-gradient(90deg, #5d5052 0%, gray 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; 
  color: transparent;
}



.replace-button {
  margin-right: 10px;
  border: 1px solid #FA5D72;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  text-transform: uppercase; 
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  color: red;
}



.replace-button:hover {
  background: var(--gradient, linear-gradient(90deg, #FA5D72 0%, #c83131 100%));
  color: #ffffff; 
}

.replace-button:hover span {
  color: #ffffff !important; 
  -webkit-text-fill-color: #ffffff !important;
}

.replace-button:hover i {
  color: #ffffff; 
  -webkit-text-fill-color: #ffffff;
}

.replace-button i, .replace-button span {
  background: var(--gradient, linear-gradient(90deg, #FA5D72 0%, #c83131 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; 
  color: transparent;
}

</style>